import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getClubsByOwner } from '../utils/clubs';
import ClubIcon from '../assets/icons/clipboard.svg';

function ClubSettingsSection({ userId, ownedClubIds }) {
  const navigate = useNavigate();
  const [clubs, setClubs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!ownedClubIds?.length) {
      setLoading(false);
      return;
    }
    getClubsByOwner(userId)
      .then(setClubs)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [userId, ownedClubIds]);

  if (!ownedClubIds?.length || loading) return null;

  return (
    <div id="settings-club-section" className="settings-section-wrapper">
      <h3 className="settings-section-header">CLUB / PROGRAM</h3>
      {clubs.map((club) => (
        <div key={club.id} className="dashboard-card settings-section-card">
          <div className="settings-row" onClick={() => navigate(`/${userId}/club/${club.id}`)}>
            <div className="settings-row-left">
              <span className="settings-row-icon">
                <img src={ClubIcon} alt="" />
              </span>
              <div className="settings-row-content">
                <span className="settings-row-label">{club.name}</span>
              </div>
            </div>
            <span className="settings-row-right">
              <span className="settings-row-chevron"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg></span>
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ClubSettingsSection;
